export default function match(when) {
  return when == null || when === true;
}